<div class="account-paused-container">
  <div class="account-paused-card">
    <div class="account-paused-icon">
      <i class="fa-solid fa-circle-pause"></i>
    </div>
    <h2 class="account-paused-title">Account Paused</h2>
    @if (userName) {
      <p class="account-paused-greeting">Hi {{ userName }},</p>
    }
    <p class="account-paused-message">Your account access has been temporarily paused.</p>

    <div class="account-paused-reason-box">
      <div class="account-paused-reason-label">
        <i class="fa-solid fa-info-circle me-1"></i> Reason
      </div>
      <p class="account-paused-reason-text">{{ pauseReason }}</p>
    </div>

    <p class="account-paused-contact">
      If you believe this is an error, please contact your administrator.
    </p>

    <div class="account-paused-actions">
      <button class="btn btn-outline-primary me-2" (click)="onProfileClicked()">
        <i class="fa-solid fa-user me-1"></i> My Profile
      </button>
      <button class="btn btn-primary" (click)="onLogoutClicked()">
        <i class="fa-solid fa-sign-out-alt me-1"></i> Logout
      </button>
    </div>
  </div>
</div>
